module.exports = require('./helpers/bundle-url').getBundleURL('2LpMj') + "sm.7f63793f.png" + "?" + Date.now();